import { cn } from '../../../lib/utils'

export const StatCard = ({ title, value, subtitle, accent = 'primary' }) => {
  const accentClass = {
    primary:  'text-primary',
    emerald:  'text-emerald-600',
    amber:    'text-amber-600',
    rose:     'text-rose-600',
    sky:      'text-sky-600',
    violet:   'text-violet-600',
  }[accent] ?? 'text-primary'

  return (
    <div className="bg-surface rounded-base border border-border p-5">
      <p className="text-xs font-semibold text-text-muted uppercase tracking-wider">{title}</p>
      <p className={cn('text-3xl font-bold mt-1.5 tabular-nums', accentClass)}>{value}</p>
      {subtitle && <p className="text-xs text-text-muted mt-1">{subtitle}</p>}
    </div>
  )
}
